import React from "react";
var __jsx = React.createElement;
import { useState, useEffect } from "react";
import Header from "./components/Header";
import MobileSideMenu from "./components/MobileHeader/MobileSideMenu";
import Loader from "@componentsShared/Loader/Loader";
import stl from "./Layout.module.css";
import loadable from "@loadable/component";
import useIsFirstInteraction from "@hooks/useIsFirstInteraction";
import useIsWebView from "@hooks/useIsWebview";
import useIsMobile from "@hooks/useIsMobile";
import useIsIOS from "@hooks/useIsIOS";
import { BUILD_VERSION, SHOW_DEBUG_INFO } from "@globalConfig";
import useFullLoading from "@hooks/useFullLoading";
import { useCarCompareContext } from "@/_MiniApps/CarCompare/CarCompare";
import useWebView from "@hooks/useWebview";
import { useTranslation } from "@i18n";
var IS_CLIENT_LOADED = 1500;
var fallback = /*#__PURE__*/React.createElement(React.Fragment, null, "Loading...");
var DownloadAppBanner = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "components-DownloadAppBanner-DownloadAppBanner";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "components-DownloadAppBanner-DownloadAppBanner" */"./components/DownloadAppBanner/DownloadAppBanner");
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("./components/DownloadAppBanner/DownloadAppBanner");
    }
    return eval('require.resolve')("./components/DownloadAppBanner/DownloadAppBanner");
  }
}, fallback);
var MobileFooter = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "components-MobileFooter-MobileFooter";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "components-MobileFooter-MobileFooter" */"./components/MobileFooter/MobileFooter");
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("./components/MobileFooter/MobileFooter");
    }
    return eval('require.resolve')("./components/MobileFooter/MobileFooter");
  }
}, fallback);
var Footer = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "components-Footer";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "components-Footer" */"./components/Footer");
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("./components/Footer");
    }
    return eval('require.resolve')("./components/Footer");
  }
}, fallback);
var StickyBottomSlot = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "components-StickyBottomSlot-StickyBottomSlot";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "components-StickyBottomSlot-StickyBottomSlot" */"./components/StickyBottomSlot/StickyBottomSlot");
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("./components/StickyBottomSlot/StickyBottomSlot");
    }
    return eval('require.resolve')("./components/StickyBottomSlot/StickyBottomSlot");
  }
}, fallback);
var ContactUsPopUp = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "components-ContactUsPopUp-ContactUsPopUp";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "components-ContactUsPopUp-ContactUsPopUp" */"./components/ContactUsPopUp/ContactUsPopUp");
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("./components/ContactUsPopUp/ContactUsPopUp");
    }
    return eval('require.resolve')("./components/ContactUsPopUp/ContactUsPopUp");
  }
}, fallback);
function Layout(props) {
  var webview = useWebView();
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var loading = typeof props.loading === 'boolean' ? props.loading : useFullLoading();
  var isWebView = useIsWebView();
  var isIos = useIsIOS();
  var isMobile = useIsMobile();
  var isFirstInteraction = useIsFirstInteraction();
  var isTracking = !!props.tracking;
  var _useState = useState(false),
    isClientLoaded = _useState[0],
    setIsClientLoaded = _useState[1];
  var _useCarCompareContext = useCarCompareContext(),
    hasCarsToCompare = _useCarCompareContext.hasCarsToCompare,
    isCompareBarAllowed = _useCarCompareContext.isCompareBarAllowed;

  // Replicate componentDidMount
  useEffect(function () {
    setDocHeight();
    window.addEventListener("resize", setDocHeight);
    window.addEventListener("orientationchange", setDocHeight);
    return function () {
      window.removeEventListener("resize", setDocHeight);
      window.removeEventListener("orientationchange", setDocHeight);
    };
  }, []);
  var setDocHeight = function setDocHeight() {
    document.documentElement.style.setProperty("--vh", "".concat(window.innerHeight / 100, "px"));
  };
  if (__IS_CSR__) {
    var _window$location$sear;
    IS_CLIENT_LOADED = ((_window$location$sear = window.location.search.split('IS_CLIENT_LOADED=')) === null || _window$location$sear === void 0 ? void 0 : _window$location$sear[1]) || IS_CLIENT_LOADED;
  }
  useEffect(function () {
    setTimeout(function () {
      setIsClientLoaded(true);
    }, IS_CLIENT_LOADED);
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("a", {
    href: "#main-content",
    className: stl.skipLink
  }, "Skip to main content"), /*#__PURE__*/React.createElement("div", {
    className: [props.authenticationMsg ? stl.hasAuthPad : undefined,
    /* 70px bottom clearance existed for the bottom nav bar.
       Only the sticky CTA still occupies that space now, so
       `hasNavBar` pages no longer reserve a dead gap. */
    props.customStikeyButton ? stl.hasNavBar : undefined, isWebView ? "webview" : "", __IS_CSR__ && isClientLoaded ? "isLoaded" : "", isTracking ? "isTracking" : "", isIos ? "IOS" : "", "MainContainerLO"].join(" ")
  }, !props.disableLoader && loading && /*#__PURE__*/React.createElement(Loader, null), /*#__PURE__*/React.createElement(Header, {
    setUnbxdPage: props.setUnbxdPage,
    showSearchBar: props.showSearchBar,
    custommobileHeader: props.custommobileHeader,
    custommobileHeaderFragmentOnly: props.custommobileHeaderFragmentOnly,
    mobileHasBack: props.mobileHasBack,
    mobileHasTitle: props.mobileHasTitle,
    mobileNoLogo: props.mobileNoLogo,
    burgrMenuisCncl: props.burgrMenuisCncl,
    logoNotClickable: props.logoNotClickable,
    revampedSearch: props.revampedSearch,
    tracking: props.tracking,
    hideSideMenue: props.hideSideMenue,
    hideBurgerMenu: props.hideBurgerMenu,
    hideHeaderOnmobile: props.hideHeaderOnmobile,
    straightHeader: props.straightHeader,
    showUserAvatar: props === null || props === void 0 ? void 0 : props.showUserAvatar,
    showCartIcon: props === null || props === void 0 ? void 0 : props.showCartIcon,
    switchLink: props.switchLink,
    desktopNavVariant: props.desktopNavVariant,
    mobileHeaderVariant: props.mobileHeaderVariant,
    mobileHeaderActions: props.mobileHeaderActions
  }), !isWebView && isMobile && !props.hideAppBanner && /*#__PURE__*/React.createElement(DownloadAppBanner, {
    hideDownloadBanner: props === null || props === void 0 ? void 0 : props.hideDownloadBanner
  }), /*#__PURE__*/React.createElement("main", {
    id: "main-content",
    className: [props.mainClass ? props.mainClass : undefined].join(" ")
  }, props === null || props === void 0 ? void 0 : props.children), !isMobile && !props.hideFooter && /*#__PURE__*/React.createElement(Footer, {
    hideFooterWithoutAuthMsg: props.hideFooterWithoutAuthMsg,
    authenticationMsg: props.authenticationMsg
  }), isMobile && props.hasMobFooter && /*#__PURE__*/React.createElement("div", {
    className: "m-show"
  }, /*#__PURE__*/React.createElement(MobileFooter, null)), hasCarsToCompare() && isCompareBarAllowed() ? /*#__PURE__*/React.createElement(React.Fragment, null) : isMobile && props.customStikeyButton && /*#__PURE__*/React.createElement(StickyBottomSlot, null, props.customStikeyButton)), /*#__PURE__*/React.createElement(MobileSideMenu, {
    switchLink: props.switchLink
  }), /*#__PURE__*/React.createElement("div", {
    id: "popUpId"
  }), props.hasContactUs && isFirstInteraction && /*#__PURE__*/React.createElement(ContactUsPopUp, null), SHOW_DEBUG_INFO && BUILD_VERSION && /*#__PURE__*/React.createElement("div", {
    id: "build-version",
    className: "text-xs w-full mt-5 text-lightGray text-center"
  }, /*#__PURE__*/React.createElement("span", null, t("version", {
    ns: "web_aside_menu"
  }), ": ", /*#__PURE__*/React.createElement("strong", null, BUILD_VERSION))));
}
export default Layout;